import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { retiredBlogRedirect } from "./lib/blogPublishingRules";

const errorMiddleware = createMiddleware().server(async ({ next, request }) => {
  const retiredPost = retiredBlogRedirect(request);
  if (retiredPost) return retiredPost;
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  // attachSupabaseAuth intentionally omitted: no server function requires a signed-in user,
  // and including it shipped the whole database client on every page.
  requestMiddleware: [errorMiddleware],
}));
